/** Fields required on Submit/Publish per catalog method (mirrors backend catalog-validation.ts). */

export type CatalogMethod = "MANUAL" | "ISBN" | "JOURNAL" | "E_RESOURCE" | "BULK";

export const PUBLISH_REQUIRED_BIBLIO: Record<CatalogMethod, string[]> = {
  MANUAL: [
    "title",
    "authors",
    "isbn",
    "publisher",
    "placeOfPublication",
    "publishedDate",
    "callNumber",
    "bindingType",
    "subjects",
  ],
  ISBN: [
    "title",
    "authors",
    "isbn",
    "publisher",
    "placeOfPublication",
    "publishedDate",
    "callNumber",
    "bindingType",
    "subjects",
  ],
  JOURNAL: ["title", "issn", "editors", "subjects", "journal.volumeNumber"],
  E_RESOURCE: ["title", "type", "subjects"],
  BULK: ["subjects"],
};

export const PUBLISH_REQUIRED_ITEM_DEFAULTS = [
  "itemTypeId",
  "locationId",
  "conditionCode",
  "statusCode",
] as const;

export const DRAFT_REQUIRED_BIBLIO = ["title"] as const;

export const PUBLISH_REQUIRED_PER_COPY = ["acquisitionMode"] as const;

export const BULK_REQUIRED_ROW_FIELDS = ["subjects", "acquisitionMode"] as const;

export function isFieldRequiredOnPublish(method: CatalogMethod, field: string): boolean {
  return PUBLISH_REQUIRED_BIBLIO[method]?.includes(field) ?? false;
}

export function isItemFieldRequiredOnPublish(method: CatalogMethod, field: string): boolean {
  if (method === "E_RESOURCE" || method === "BULK") return false;
  return (PUBLISH_REQUIRED_ITEM_DEFAULTS as readonly string[]).includes(field);
}

export function isCopyFieldRequiredOnPublish(method: CatalogMethod, field: string): boolean {
  if (method === "E_RESOURCE" || method === "BULK") return false;
  return (PUBLISH_REQUIRED_PER_COPY as readonly string[]).includes(field);
}

export function isBulkRowFieldRequired(field: string): boolean {
  return (BULK_REQUIRED_ROW_FIELDS as readonly string[]).includes(field);
}
